/**
 * The connector addresses a user adds to their AI client.
 *
 * The gateway serves two of them from one base: `<base>/mcp` aggregates the
 * tools of every connected platform, and `<base>/mcp/custom` serves the custom
 * servers of the brand that is active for the key. Both take the same key.
 */

/** The gateway's base connector address, keyed by deploy env. */
export const GATEWAY_URL_BY_ENV: Record<string, string> = {
  DEV: 'https://gateway.kodeia.com/mcp',
  STAGING: 'https://gateway.adup.io/mcp',
  LIVE: 'https://gateway.adup.io/mcp',
};

/** The base connector address (`<gateway>/mcp`) for a deploy env. */
export const getConnectorAddress = (env: string): string =>
  GATEWAY_URL_BY_ENV[env] ?? GATEWAY_URL_BY_ENV.LIVE;

/**
 * The address that serves a brand's custom servers, derived from the base
 * connector address so the two can never point at different gateways.
 */
export const getCustomConnectorAddress = (connectorAddress: string): string =>
  `${connectorAddress.replace(/\/+$/, '')}/custom`;
